import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Content, Platform, AlertController, ToastController, ViewController } from 'ionic-angular';
import { PhotoLibrary } from './../../../../providers/my-photo-library';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { CallNumber } from '@ionic-native/call-number';
import { AbstractPage } from '../../../_com/abstract-page';
import { ReserveAction } from '../../../../actions/reserve.action';
import { AuthStore } from '../../../../stores/auth-store';
import Utils from '../../../../_com/utils';
import _ from 'underscore';
import moment from "moment";

/**
 * Generated class for the ReserveDetailPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: "page-reserve-pickup-edit",
  templateUrl: "reserve-pickup-edit.html",
})
export class ReservePickupEditPage extends AbstractPage {
  // data:any;
  name_others: String;
  tel_others: String;
  relation_other: String;
  child = {};
  reserve = {};
  family = {};
  pickup = {};
  pickup_time = new Date();
  isFamily2Exists = false;
  _moment = moment;

  data = {
    id: "",
    datetime: {
      input: {
        date: new Date(),
        time: null,
      },
    },
    pickup: {},
    family: {},
    children: [{}],
    memo: "",
    type: "",
    status: null,
    bathRequest: null,
  };

  _utils = Utils;

  // ご家族の入力が終われば、スタッフがパスワードを入力して元の画面に戻る
  isStaffConfirm: boolean = false;
  staffPassword: string = "";

  // スタッフが記入しているか？
  // - スタッフ記入の場合は、パスワード入力画面は不要
  isStaff: boolean = false;

  @ViewChild(Content) content: Content;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public reserveAction: ReserveAction,
    private pv: PhotoViewer,
    private pl: PhotoLibrary,
    private plt: Platform,
    private callNumber: CallNumber,
    private alertController: AlertController,
    private toastController: ToastController,
    protected authStore: AuthStore,
    public viewController: ViewController
  ) {
    super();

    //編集データ設定
    if (this.navParams.get("id")) {
      this.data.id = this.navParams.get("id");
    }

    if (this.navParams.get("family")) {
      this.refrectFamily(this.navParams.get("family"));
    }

    if (this.navParams.get("date")) {
      this.data.datetime.input.date = this.navParams.get("date");
    }

    if (this.navParams.get("time")) {
      this.data.datetime.input.time = this.navParams.get("time");
    }

    if (this.navParams.get("bathRequest")) {
      this.data.bathRequest = this.navParams.get("bathRequest");
    }

    if (this.navParams.get("status")) {
      this.data.status = this.navParams.get("status");
    }

    this.isStaff = this.navParams.get("isStaff") || false;

    if (this.navParams.get("pickup")) {
      // お迎え情報が登録されている場合
      this.data.pickup = this.navParams.get("pickup");
      this.pickup_time = new Date(this.data.pickup["pickup_time"]);
    } else {
      // お迎え情報が登録されていない場合
      this.pickup_time = this.data.datetime.input.time[1];
    }

    this.pl; //for TSLint
    this.pv; //for TSLint
    this.plt; //for TSLint
    this.callNumber; //for TSLint
  }

  /**
   * 画面が呼び出される前にロード
   */
  ionViewDidLoad() {}

  /**
   * 時間を見やすい形に変換
   */
  convertTime(data) {
    if (!data) return "-";
    return this._Utils.date.format(new Date(data), "HH:mm");
  }

  // チェックされた場合、他の項目を非活性にするメソッドを作成
  toDisabled(pickup_family, num) {
    if (num === 1) {
      if (pickup_family) {
        if (this.isFamily2Exists) {
          document.getElementById("pickup_info_2").style.display = "none";
        }
        document.getElementById("pickup_info_3").style.display = "none";
      } else {
        if (this.isFamily2Exists) {
          document.getElementById("pickup_info_2").style.display = "block";
        }
        document.getElementById("pickup_info_3").style.display = "block";
      }
    } else if (num === 2) {
      if (pickup_family) {
        document.getElementById("pickup_info_1").style.display = "none";
        document.getElementById("pickup_info_3").style.display = "none";
      } else {
        document.getElementById("pickup_info_1").style.display = "block";
        document.getElementById("pickup_info_3").style.display = "block";
      }
    } else if (num === 3) {
      if (pickup_family) {
        document.getElementById("pickup_info_1").style.display = "none";
        if (this.isFamily2Exists) {
          document.getElementById("pickup_info_2").style.display = "none";
        }
      } else {
        document.getElementById("pickup_info_1").style.display = "block";
        if (this.isFamily2Exists) {
          document.getElementById("pickup_info_2").style.display = "block";
        }
      }
    }

    return true;
  }

  /**
   * お迎え内容を保存する
   * pickup_family_2: 第2連絡先
   * pickup_family_other: その他
   */
  save(pickup_family_1, pickup_family_2, pickup_family_other) {
    let othersInfo = {
      name: this.name_others,
      tel: this.tel_others,
      relation: this.relation_other,
    };

    // データチェック: その他の連絡先が選ばれた場合のみ
    // ReserveRegistPageにも同様の記述あり
    if (pickup_family_other) {
      if (this.checkData(othersInfo)) return;
    }

    if (!pickup_family_1 && !pickup_family_2 && !pickup_family_other) {
      this.alert(this.alertController, "連絡先を選択してください。");
      return;
    }
    /**
     * @param
     * this.data['pickup']: 入力された送迎情報
     * pickup_family_1:第１連絡先
     * pickup_family_2:第2連絡先
     * pickup_family_other: その他の連絡先
     * this.name_others：その他の連絡先「名前」
     * this.tel_others：その他の連絡先「電話番号」
     * this.relation_others：その他の連絡先「続柄」
     */
    this.data["pickup"] = this.makePickupData(
      this.data.pickup,
      pickup_family_1,
      pickup_family_2,
      pickup_family_other,
      this.data.family,
      othersInfo
    );
    this.data["pickup"]["pickup_time"] = this.pickup_time; // お迎えの時間

    // 登録
    this.confirm(
      this.alertController,
      "入力された内容でお迎え情報を送信します。よろしいですか？",
      () => {
        this.reserveAction.save(this.data).subscribe((res) => {
          this.toast(this.toastController, "お迎え情報を更新しました。");

          // スタッフが記入している場合は、普通に閉じる
          if (this.isStaff) {
            this.navCtrl.pop();
          } else {
            this.isStaffConfirm = true;
          }
        });
      }
    );
  }

  // その他の連絡先が選ばれた場合のみチェックする
  checkData(othersInfo) {
    let isError = false;
    if (othersInfo?.name === "") {
      this.alert(this.alertController, "お名前を入力してください");
      isError = true;
      return isError;
    }
    if (othersInfo?.tel === "") {
      this.alert(this.alertController, "お電話番号を入力してください");
      isError = true;
      return isError;
    }
    if (!othersInfo?.tel?.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/)) {
      this.alert(this.alertController, "正しい携帯電話番号を入力してください");
      isError = true;
      return isError;
    }
    if (othersInfo?.relation === "") {
      this.alert(this.alertController, "続柄を入力してください");
      isError = true;
      return isError;
    }
    return isError;
  }

  /**
   * 家族情報を画面へ反映する
   */
  refrectFamily(family) {
    this.data.family = family;

    if (this.navParams.get("type")) {
      //前画面からの引き継ぎの場合、パラメータのお客様区分を設定
      this.data["type"] = this.navParams.get("type");
    } else {
      //ご家族選択からの新規申し込みの場合は、利用者データのお客様区分を設定
      this.data["type"] = family["type"];
    }

    if (this.data.family["tel2"]) {
      this.isFamily2Exists = true;
    }

    this.data.children = [];
    for (let index in family.children) {
      family.children[index]["Child"]["birthday"] = new Date(
        family.children[index]["Child"]["birthday"]
      );
      this.data.children.push(family.children[index]["Child"]);
    }

    this.refreshChildrenTimeData();
  }

  /**
   * 子供用の時間データフォーマット
   */
  refreshChildrenTimeData() {
    for (let index in this.data.children) {
      this.refleshTimeData(this.data.children[index]);
    }
  }

  /**
   * キャンセル処理
   */
  cancel() {
    //入力項目タッチ無し
    if (!this.hasTouched()) {
      if (this.isStaff) {
        this.viewController.dismiss();
      } else {
        this.isStaffConfirm = true;
      }
      return;
    }

    //入力項目タッチありで、画面を閉じる
    this.confirm(
      this.alertController,
      "画面を閉じます。よろしいですか？",
      () => {
        if (this.isStaff) {
          this.viewController.dismiss();
        } else {
          this.isStaffConfirm = true;
        }
      }
    );
  }

  close() {
    // TODO: ご家族に入力頂いた後の画面は、共通の画面となるのでコンポーネント化すべき
    // 端末をご家族の方にお渡ししているため、パスワード認証をかけておく
    if (this.staffPassword === "8710") {
      this.viewController.dismiss();
    } else {
      alert("パスワードが異なります");
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/reserve/pickup/edit/reserve-pickup-edit.ts